import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-notify-warning',
  templateUrl: './notify-warning.component.html',
  styleUrls: ['./notify-warning.component.scss']
})
export class NotifyWarningComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotifyWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close()
  }

}
